import React from "react";
import ReactDOM from "react-dom/client";
import "react-quill/dist/quill.snow.css";
import "jsvectormap/dist/css/jsvectormap.css";
import "react-toastify/dist/ReactToastify.css";
import "react-modal-video/css/modal-video.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "./firebase.js";
import { toast } from "react-toastify";



const root = ReactDOM.createRoot(document.getElementById("root"));

getToken(messaging, {
  vapidKey:
    "BJyo7Gej1zE3vlOcUHb2-NtsWGercAyDo7ZsqnSbL7pS-IFIFY1a3-P0Fup2n2Y8FhfM5j7eepXGNxOPcmjIUTY",
})
  .then((currentToken) => {
    if (currentToken) {
      console.log(":dart: FCM Token:", currentToken);
      // backend per bhejo token yahan se
    } else {
      console.warn(
        ":warning: No registration token available. Request permission to generate one."
      );
    }
  })
  .catch((err) => {
    console.error("FCM token error:", err);
  });
// :white_check_mark: Foreground messages
onMessage(messaging, (payload) => {
  console.log(":bell: Foreground Notification:", payload);
  toast.success(payload.notification.body);


});


root.render(
  <>
    <App />
  </>
);

reportWebVitals();
